import { z } from 'zod';
import {
  ContactSubFormSchema,
  NonStandardToolsFieldSchema,
  OptionLabelValueSchema,
} from '../../utils/schemas';
import { TicketDetailForms } from '../DefinedFormTypes';

export const MoveFormSchema = z.object({
  formType: z.literal(TicketDetailForms.enum.Move),
  equipmentOrServicesBeingMoved: OptionLabelValueSchema,
  whereIsTheService: z.string().trim().nonempty('Required'),
  whereDoesItNeedToBeMoved: z.string().trim().nonempty('Required'),
  techToTestWith: z.discriminatedUnion('techToTestWith', [
    z.object({ techToTestWith: z.literal('Yes') }),
    z.object({ techToTestWith: z.literal('No') }),
  ]),
  itTestingContacts: z.array(ContactSubFormSchema),
  nonStandardTools: NonStandardToolsFieldSchema,
});

export type MoveForm = z.infer<typeof MoveFormSchema>;
